import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 0;
  padding: 0 8px;
  box-sizing: border-box;

  @media (min-width: 400px) {
    padding: 0 16px;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
  align-items: center;

  @media (min-width: 360px) {
    justify-content: flex-start;
  }
`;

export default {
  Wrapper,
  Actions,
};
